import React from 'react';
import { Link } from 'react-scroll';

import Toggle from '../Toggle/Toggle';

import { navList } from '../../Constant/constants';

import './Navbar.css';

const navbar = () => {
  return (
    <div className="n-wrapper" id="Navbar">
      {/* left */}
      <div className="n-left">
        <div className="n-name">MyHub</div>
        <Toggle />
      </div>
      {/* right section */}

      <div className="n-right">
        <div className="n-list">
          {navList.map((item) => (
            <ul style={{ listStyleType: 'none' }}>
              <li>
                <Link to={item.link} smooth={true}>
                  {item.displayName}
                </Link>
              </li>
            </ul>
          ))}
        </div>
        <Link to="contact" smooth={true}>
          <button className="button n-button">Contact</button>
        </Link>
      </div>
    </div>
  );
};

export default navbar;
